module.exports = __webpack_public_path__ + "static/media/1001lwu.49eee99b.JPG";